import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import PaymentEditor from './PaymentEditor';

function EditPayment() {
	const { id } = useParams();
	const navigate = useNavigate();
	const { state } = useLocation();
	const returnTo = state?.returnTo || `/AdminScreen/payments/payment/${id}`;

	return (
		<EntityList>
			<Helmet>
				<title>Editar Cobro</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Cobros', to: '/AdminScreen/payments' },
					{ label: 'Editar Cobro' },
				]}
				title='Editar Cobro'
				subtitle='Actualizá los datos del cobro.'
			/>
			<PaymentEditor
				mode='edit'
				paymentId={id}
				onCancel={() => navigate(returnTo)}
				onSaved={() => navigate(returnTo)}
				saveLabel='Guardar'
			/>
		</EntityList>
	);
}

export default EditPayment;
